import {JSONStreamer} from "abusesa-js/DataStreamer";

import * as csv from "lib/csv";

export default class multixhr extends JSONStreamer {
    constructor(...args) {
        super(...args);

        this.registerParser("text/csv", csv.streamParser);
        if ("EventSource" in window) {
            //Register parser for text/event-stream that will throw
            //an error and cause switch to next streamer which will
            //be EventStream streamer
            this.registerParser("text/event-stream", function() {
                throw Error("Use EventSource for event-stream parsing");
            });
        }
    }
}



// WEBPACK FOOTER //
// ./src/kpi/common/MultiXHR.js